module.exports = __webpack_public_path__ + "img/img_title.d34c6d8b.png";